import React from 'react';
import decklepro_img from '../images/decklepro.png'; // Use your product image here
import { useNavigate } from 'react-router-dom';

const Product = () => {
    const navigate = useNavigate();

    const handleCardClick = () => {
        navigate('/deckle-matching-software');
    };

    return (
        <section id="product" className="product-section product-lean py-5">
            <div className="container" data-aos="fade-up">
                <div className="row justify-content-center">
                    <div className="col-lg-10">
                        <div
                            className="product-card product-panel p-4 p-md-5 shadow-sm"
                            style={{ cursor: 'pointer' }}
                            onClick={handleCardClick}
                            id="decklepro"
                        >
                            <div className="row g-4 align-items-center">
                                <div className="col-md-4 text-center">
                                    <div className="product-logo-frame">
                                        <img
                                            alt="DecklePro deckle matching software logo"
                                            height={120}
                                            width={150}
                                            src={decklepro_img}
                                            loading="lazy"
                                            decoding="async"
                                        />
                                    </div>
                                </div>
                                <div className="col-md-8">
                                    <span className="section-kicker">Product</span>
                                    <h2 className="mb-3">
                                        <span style={{ color: 'var(--anmatics-dark)' }}>Deckle</span>
                                        <span style={{ color: 'var(--anmatics-secondary)' }}>Pro</span>
                                    </h2>
                                    <p className="text-muted mb-4">
                                        Deckle matching and reel slitting optimization software for paper mills. Plan faster,
                                        reduce trim waste, and manage configurable workflows for orders, stock, production, dispatch, invoices, gate passes, lab reports, and mill documents in one system.
                                    </p>
                                    <div className="product-points mb-4">
                                        <span>Optimization engine</span>
                                        <span>Configurable workflows</span>
                                        <span>Reports & documents</span>
                                    </div>
                                    <button className="btn btn-gradient btn-lg rounded-pill shadow-sm">
                                        View DecklePro
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Product;
